<template>
	<div class="card mt-4">
        <div class="card-header">
	    	<div class="d-flex justify-content-between container-fluid">
	            <div class="text-muted fs-19">
	            	<strong>Registros</strong>
	            </div>
		    </div>
	    </div>
	    <div class="card-body">
	    	<div class="row">
				<div class="col-md-12">
		            <receita-table 
		            	:key="receitaTableKey"
		            	:date="date"
		            	@show="show"
		            	@update="update"
		            	@destroy="destroy">
		            </receita-table>
		        </div>
		    </div>
	    </div>
	</div>
</template>

<script>
	export default {
		props: ['date', 'receitaTableKey'],
		methods: {
			show(id){
            	this.$emit('show', id);
	        },
	        update(id){
	            this.$emit('update', id);
	        },
	        destroy(id){
	            this.$emit('destroy', id);
	        }
		},
		/*watch: {
			receitaTableKey(){
				this.getDados()
			}
		}*/
	}
</script>